export default __webpack_public_path__ + "static/media/ico-inactive.2662c9ec.svg";